import {
  Table,
  Modal,
  Actions,
  BellIcon,
  useState,
  useSearch,
  ErrorAlert,
  ModalOpenBtn,
  PageHero,
  SearchToggle,
  modalHandler,
  useFetchData,
  useTableColumns,
  getNotifications,
  TableRowsPerPage,
} from "@";
import { updateStatus } from "./utils/api";
import { searchValues } from "./utils/options";
import MultiSearch from "./components/MultiSearch";
import tableColumns from "./components/tableColumns";

const Index = () => {
  // State to manage modal data
  const [modalData, setModalData] = useState({});

  // Search state and update function
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data with pagination and error handling
  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getNotifications,
    params: [search.values],
  });

  // Define table columns with actions
  const columns = useTableColumns(tableColumns, (row) => (
    <Actions row={row} notDelete notEdit show={handleShow} />
  ));

  // Handle show action for modal
  const handleShow = async (row) => {
    setModalData(row);
    modalHandler();
    await updateStatus(row.id);
  };

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />

      {/* Modal for notification details */}
      <ModalOpenBtn hidden />
      <Modal title="عرض التنبيه">
        <main className="relative p-6">
          <div className="mb-6">
            <h5 className="font-bold">تاريخ التنبيه</h5>
            <p className="text-gray-600">{modalData?.submittingDate}</p>
          </div>

          <div>
            <h5 className="font-bold">تفاصيل التنبيه</h5>
            <p className="text-gray-600">{modalData?.body}</p>
          </div>
        </main>
      </Modal>

      <main className="table-card mt-8 relative overflow-hidden">
        <PageHero
          eyebrow="الإشعارات"
          title="الاشعارات"
          count={data?.length}
          icon={BellIcon}
          hideCount={isLoading}
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size: size })}
          />
          {/* Toggle search form */}
          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        {/* Multi-search form */}
        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        {/* Table with data */}
        <Table
          data={data}
          pagination={pg}
          columns={columns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
